// 画像表示
import React from 'react';

interface Props {
  value: string;
}

const Image: React.FC<Props> = ({ value }) => {
  return (
    <div>
      <img
        src={`${location.origin}${process.env.MIX_MOCK_URL}/${value}`}
        className="img-fluid"
      ></img>
    </div>
  );
};

export default Image;
